import { createContext } from 'react';

const GlobalTabsContext = createContext();
export default GlobalTabsContext;
